import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from "@mui/material";
import Chart from 'react-apexcharts';

function APQ(props) {
    const getColor = () => {
        let color;
        try {
            if (props.title == "AVA" && props.value >= 92) {
                color = "#4caf50"
            } else if (props.title == "AVA" && props.value >= 82 && props.value <= 91.99) {
                color = "#ffeb3b"
            } else if (props.title == "AVA" && props.value < 82) {
                color = "#e53935"
            } else if (props.title == "PER" && props.value >= 95) {
                color = "#4caf50"
            } else if (props.title == "PER" && props.value >= 85 && props.value <= 94.99) {
                color = "#ffeb3b"
            } else if (props.title == "PER" && props.value < 85) {
                color = "#e53935"
            } else if (props.title == "QUA" && props.value >= 98) {
                color = "#4caf50"
            } else if (props.title == "QUA" && props.value >= 95 && props.value <= 97.99) {
                color = "#ffeb3b"
            } else if (props.title == "QUA" && props.value < 95) {
                color = "#e53935"
            }
            return color;
        }
        catch {
            console.log()
        }
    }
    return (
        <>
            <Typography color="black" fontSize={'20px'} fontWeight="bold" align='left' sx={{ pt: 3, ml: 1 }}>
                {props.title}
            </Typography>
            <Box sx={{ display: 'block' }}>
                <Chart
                    options={{
                        chart: {
                            type: 'radialBar',
                            offsetY: -15,
                            offsetX: -30,
                            toolbar: {
                                show: false
                            }
                        },
                        plotOptions: {
                            radialBar: {
                                hollow: {
                                    margin: 15,
                                    size: "60%",
                                },

                                dataLabels: {
                                    showOn: "always",
                                    name: {
                                        offsetY: 15,
                                        show: true,
                                        color: "#888",
                                        fontSize: 12,
                                        fontFamily: 'CPF_Imm_Sook'
                                    },
                                    value: {
                                        offsetY: -10,
                                        color: "#111",
                                        fontSize: 22,
                                        fontFamily: 'CPF_Imm_Sook',
                                        show: true
                                    }
                                }
                            }
                        },
                        colors: [getColor()],
                        labels: ['Target ' + props.target + '%'],
                        fill: {
                            type: "gradient",
                            gradient: {
                                shade: "dark",
                                type: "vertical",
                                gradientToColors: [getColor()],
                                stops: [0, 100]
                            }
                        },
                    }}
                    series={props.value != 'NA' ? props.value : 0}
                    type="radialBar"
                    width="100%"
                    height="100%"
                />
            </Box>
        </>
    )
}

APQ.propTypes = {

}

export default APQ

